
import { Col, Container, Row, Accordion } from 'react-bootstrap';
import { s3_img_url } from '../../../Helper/request';

const Order_include = ({type}) => {
  return (
    <div className="your_order_includes">
 
      <div className={`your_order_includes_inner customTemplate`}>
        <Container fluid>
          <Row className='custom-no-padding align-items-center'>
            <Col md={12} lg={5} sm={12} className="mobile_hide p-0">
              <img className="includes_img" src={type==="custom" ? `${s3_img_url}product_list/include.png` : `${s3_img_url}pdp_include.webp`} alt='YOUR ORDER INCLUDES'/>
            </Col>
            <Col md={12} lg={7} sm={12}>
            <div className='d-flex align-items-center justify-content-center pt-5 pb-5'>
              <div className='w-100'>
               <h2 className='outerTitle text-center mb-4 text-uppercase'>{type==="custom" ? "YOUR CUSTOM ORDER INCLUDES" : "Your Order Includes"}</h2>
              <Accordion>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>EASY 60 DAY RETURNS</Accordion.Header>
                  <Accordion.Body>
                    We want you to love everything about your jewelry so if
                    something isn’t just right, we give you 60 days to return
                    your jewelry, no questions asked.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>FREE LIFETIME WARRANTY</Accordion.Header>
                  <Accordion.Body>
                    If you bought it at Wedding Day Diamonds, it's guaranteed.
                    It's just that simple. Even if you lose a diamond from a
                    ring you purchased from Wedding Day Diamonds, we will
                    replace it. If you choose to trade in your diamond, simply
                    find a diamond that retails for at least $1 more than the
                    current market value. All maintenance is free forever. The
                    only thing we are unable to guarantee is that you won't lose
                    your jewelry. For that you need insurance.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    365 DAY PERFECT RING PROMISE
                  </Accordion.Header>
                  <Accordion.Body>
                    If at any time during the first year of ownership you decide
                    that your engagement ring isn’t perfect, we will do whatever it takes
                    to make it perfect, up to and including a total remake.
                    We’re able to make this promise because we have an exclusive
                    Perfect Ring Promise, unequaled quality control, and most
                    important, an absolute commitment to our clients. We are
                    happy to exchange your engagement ring up to a year from your purchase
                    date. You are allowed one exchange within one year. Custom
                    orders ARE included.
                  </Accordion.Body>
                </Accordion.Item>
                {/* <Accordion.Item eventKey="4">
                      <Accordion.Header>ONE TREE PLANTED</Accordion.Header>
                      <Accordion.Body>
                      Hide this one for now. We don’t have anything to put here at this time but we’d like the ability to add it in later.
                      </Accordion.Body>
                    </Accordion.Item> */}
                <Accordion.Item eventKey="5">
                  <Accordion.Header>EARN DIAMOND DOLLARS</Accordion.Header>
                  <Accordion.Body>
                    Receive 2% back with every purchase you make and redeem your
                    credit in store. Some exclusions apply. See store for
                    details.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              </div>
            </div>
          
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Order_include;
